import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { CommuterTrafficType } from './commuter-traffic-type.interface';
import { CommuterTrafficTypeService } from './commuter-traffic-type.service';

const service = new CommuterTrafficTypeService();

export interface CommuterTrafficTypeState {
   commuterTrafficTypes: Array<CommuterTrafficType>;
}

const CommuterTrafficTypeStore: Module<CommuterTrafficTypeState, StoreState> = {
   namespaced: true,
   state: {
      commuterTrafficTypes: [],
   },
   getters: {
      commuterTrafficTypes(state) {
         return state.commuterTrafficTypes;
      },
   },
   mutations: {
      setCommuterTrafficTypes(state, newValue: Array<CommuterTrafficType>) {
         state.commuterTrafficTypes = newValue;
      },
   },
   actions: {
      async getCommuterTrafficTypes(context, query?: LocationQuery) {
         return await service.getCommuterTrafficTypes(query).then((response) => {
            context.commit('setCommuterTrafficTypes', response);
            return response;
         });
      },
      async getContractCommuterTrafficTypes(context, query?: LocationQuery) {
         return await service.getContractCommuterTrafficTypes(query).then((response) => {
            return response;
         });
      },
   },
};

export default CommuterTrafficTypeStore;
